export default __webpack_public_path__ + "static/media/bg-payment-button.0f63ca72.svg";